var _defs, _tspan;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCqdr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "75.792587mm",
    height: "132.29166mm",
    viewBox: "0 0 75.792587 132.29166",
    id: "svg94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs88"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(0,-164.70835)"
  }, /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "10.58333302px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.26458332
    },
    x: 16.630953,
    y: 117.83928,
    id: "text98"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan100",
    x: 16.630953,
    y: 127.62886
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "50.79999924px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text'",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.26458332
    },
    x: 16.630953,
    y: 111.03571,
    id: "text104"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan102",
    x: 16.630953,
    y: 158.02571,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "50.79999924px",
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text'",
      strokeWidth: 0.26458332
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g555",
    transform: "matrix(1.83946,0,0,1.83946,-0.2212252,-256.39868)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 7.4564602,268.37678 c 1.5634511,1.92424 2.8863718,3.84849 4.2092918,5.77274 0.120265,0.48106 0.601327,1.20265 0.601327,1.44318 0,0 0,0.24053 -0.120265,0.3608 -0.240531,0.3608 -0.601328,0.48106 -1.08239,0.48106 -0.360796,0 -1.2026544,-0.24053 -1.5634508,-0.36079 -0.4810619,0 -1.0823892,-0.24054 -1.5634511,-0.24054 -4.0890261,0 -7.81725572,4.08903 -7.81725572,9.26045 0,4.81061 4.08902602,9.50097 11.18468862,14.91291 0.721593,0.60133 1.683717,0.84186 2.40531,0.84186 0.721593,0 1.443185,-0.24053 1.443185,-0.60132 0.120266,-0.24054 0.240531,-0.48107 0.240531,-0.60133 0,-0.96213 -0.721592,-1.68372 -1.563451,-2.40531 -1.202654,0 -2.285044,-2.52558 -2.525575,-3.36743 -0.240531,-0.84186 -0.360796,-1.68372 -0.360796,-2.52558 0,-3.00664 1.443186,-6.37407 4.570088,-6.9754 0.481062,-0.12026 0.962124,-0.12026 1.563451,-0.12026 2.766106,0 5.893008,1.08239 7.456459,1.68371 0.120266,0 0.240531,0.12027 0.240531,0.12027 0.360797,0.12027 0.481062,0.12027 0.721593,0.12027 0.240531,0 0.481062,-0.12027 0.481062,-0.48107 0,-1.08239 -2.525575,-4.32955 -3.607964,-5.41194 -3.607964,-4.44983 -6.614601,-8.05779 -6.614601,-13.34947 0,-0.48106 0.120265,-0.96212 0.120265,-1.32292 0.360797,-5.53221 3.848495,-10.22257 6.37407,-14.07106 0.240531,-0.48106 0.360797,-0.96212 0.360797,-1.44319 0,-0.96212 -0.360797,-1.92424 -0.360797,-1.92424 0,0 -14.3115909,-16.83717 -15.8750421,-18.52089 -0.4810618,-0.48106 -1.2026547,-0.72159 -1.803982,-0.72159 -0.9621238,0 -1.9242476,0.60133 -1.9242476,1.92425 0,0.48106 0.1202655,0.96212 0.4810619,1.56345 0.3607964,1.08239 5.7727427,6.01327 5.7727427,12.8684 0,3.60797 -1.4431857,7.69699 -5.7727427,12.26708 -0.9621238,0.96213 -1.3229202,2.04452 -1.3229202,2.76611 0,1.32292 0.9621238,2.28504 0.9621238,2.28504 z",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "medium",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.62638098
    },
    id: "path546"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 41.323984,264.76881 c 0,-2.64584 -2.164778,-4.81062 -4.810619,-4.81062 -2.64584,0 -4.810618,2.16478 -4.810618,4.81062 0,2.64584 2.164778,4.81062 4.810618,4.81062 2.645841,0 4.810619,-2.16478 4.810619,-4.81062 z",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "medium",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.62638098
    },
    id: "path548"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCqdr);
export default __webpack_public_path__ + "static/media/cqdr.788dfa75bbf72d391b446508932fbf5b.svg";
export { ForwardRef as ReactComponent };